const _ = require('lodash')

class Debouncer {
  constructor() {
    this.functions = {}
    this.time = null
  }

  wait(time) {
    this.time = time
    return this
  }

  uniqueBy(identifier) {
    this.identifier = identifier
    return this
  }

  func(functionPointer) {
    if (!this.time) throw new Error('Missing time parameter')

    if (this.identifier) {
      if (this.functions[this.identifier] && this.functions[this.identifier][functionPointer]) {
        this.functionPointer = this.functions[this.identifier][functionPointer]
        return this
      }
      this.functionPointer = _.debounce(functionPointer, this.time)
      this.functions[this.identifier] = this.functions[this.identifier] || {}
      this.functions[this.identifier][functionPointer] = this.functionPointer
      return this
    }

    if (this.functions[functionPointer]) {
      this.functionPointer = this.functions[functionPointer]
      return this
    }

    this.functionPointer = _.debounce(functionPointer, this.time)
    this.functions[functionPointer] = this.functionPointer
    return this
  }

  exec(...data) {
    this.time = null
    this.identifier = null

    this.functionPointer(...data)
  }

  clearIdentifier(identifier) {
    if (identifier) {
      delete this.functions[identifier]
    }
  }
}

// Export the instance of the class
const debouncerInstance = new Debouncer()
export default debouncerInstance
